module.exports = __webpack_public_path__ + "img/arrow-toggler-bottom-white.3ab96fd0.svg";